export function updateListTableHeaderUnilateral(state, array) {
  state.tableHeaderUnilateral = array;
}
